import $ajax from 'axios'
// import {hideLoad} from '@/tools/loading.js'
import msgWarning from '@/tools/msgwarning.js'
import { hideLoad } from '@/tools/loading.js' // 引入封装的loading方法
import api from '@/utils/api.js'

/**
 * 获取城市
 * @param {Boolean} includeDisabled 是否包括禁用城市
 * @param {Boolean} noLoading 是否需要loading
 */
async function getCity(includeDisabled, noLoading) {
  let str = ''
  if (includeDisabled) str += '&includeDisabled=true'
  // 获取城市数据
  let cityData = (await ($ajax.get('v2/cms/GetPlaces?level=2' + str, {
    noLoading: !!noLoading
  }))).data
  // 判断城市是否获取成功
  if (cityData.code !== '0') {
    msgWarning('[获取城市列表失败] ' + cityData.desc)
  } else {
    return JSON.parse(cityData.data)
  }
}

/**
 * 获取城市信息
 */
export const getAllCityInfo = async (noLoading = false) => {
  try {
    let res = await api('v2/cms/GetPlaces',noLoading)
    hideLoad()
    return res
  } catch (e) {
    console.error(e)
  }
}

async function getJxCat(noLoading) {
  // 获取分类数据
  let categories = (await $ajax.get('v2/sku/GetCategories', { noLoading })).data
  // 判断分类是否获取成功
  if (categories.code !== '0') {
    msgWarning('[获取分类列表失败] ' + categories.desc)
  } else {
    categories = JSON.parse(categories.data)
    return {
      catLevel1: categories.filter(item => item.level === 1),
      catLevel2: categories.filter(item => item.level === 2)
    }
  }
}


//获取京西商城用户信息
function getJxUser(keyword, offset, pageSize, fromTime, toTime, vendorIDs, fn) {
  $ajax.get('v2/user2/GetJxShopUsers', {
    params: {
      keyword,
      offset,
      fromTime,
      toTime,
      vendorIDs,
      pageSize
    }
  }).then(res => {
    hideLoad()
    if (res.data.code === '0') {
      fn && fn(res.data)
    } else {
      msgWarning(res.data.desc)
    }
  }).catch(err => {
    hideLoad()
  })
}


/**
 * 模块：获取商城首页菜单列表
 * 作者：张树伟
 * 日期：2022年7月7日
 * 邮箱：2966211270@qq.com
 */
function getMerchantMenu(storeID,fn) {
  if (process.env.NODE_ENV === "development") {
    var URL_AJAX = `store/sku/GetTopCategoriesByStoreIDs?storeIDs=%5B${storeID}%5D`
  }else {
    var URL_AJAX = `http://www.jxc4.com/v2/store/sku/GetTopCategoriesByStoreIDs?storeIDs=%5B${storeID}%5D`
  }

  $ajax.get(URL_AJAX)
  .then(res => {
    hideLoad()
    if (res.data.code === '0') {
      let newData = JSON.parse(res.data.data)
      fn && fn(newData)
    } else {
      msgWarning(res.data.desc)
    }
  })
  .catch(err => {
    hideLoad()
  })
}
export { getCity, getJxCat, getJxUser, getMerchantMenu }



// WEBPACK FOOTER //
// ./src/apis/common.js